var React = require('react');

function FlagSn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M170.667 423.721H8.828A8.829 8.829 0 010 414.893V97.1a8.829 8.829 0 018.828-8.828h161.839v335.449z","fill":"#73af00","key":0}),React.createElement("path",{"fill":"#ffe15a","d":"M170.67 88.277h170.67v335.45H170.67z","key":1}),React.createElement("path",{"d":"M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 01512 97.101v317.793a8.827 8.827 0 01-8.828 8.827z","fill":"#ff4b55","key":2}),React.createElement("path",{"d":"M258.04 205.777l11.693 35.062 36.959.287c2.067.017 2.924 2.654 1.261 3.881l-29.732 21.955 11.148 35.239c.623 1.971-1.62 3.601-3.302 2.399L256 283.107l-30.069 21.492c-1.682 1.202-3.925-.428-3.302-2.399l11.148-35.239-29.732-21.955c-1.663-1.228-.806-3.865 1.261-3.881l36.959-.287 11.693-35.062c.655-1.96 3.429-1.96 4.082.001z","fill":"#73af00","key":3})]);
}

FlagSn.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FlagSn;

FlagSn.default = FlagSn;
